import { render, staticRenderFns } from "./FaceDirectionResultEffectFaceRight4.vue?vue&type=template&id=85f82faa&"
import script from "./FaceDirectionResultEffectFaceRight4.vue?vue&type=script&lang=ts&"
export * from "./FaceDirectionResultEffectFaceRight4.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports